"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _each = _interopRequireDefault(require("lodash/each"));

var Utils = /*#__PURE__*/function () {
  function Utils() {
    (0, _classCallCheck2.default)(this, Utils);
  }

  (0, _createClass2.default)(Utils, [{
    key: "getIfDefined",
    value: function getIfDefined(props) {
      var definedProps = {};
      (0, _each.default)(props, function (value, name) {
        if (value !== undefined) {
          definedProps[name] = value;
        }
      });
      return definedProps;
    }
  }]);
  return Utils;
}();

var _default = new Utils();

exports.default = _default;